import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { AcademicTitleSearchResultDto, ApplicationType, CreateMutOutput, MySironaGetDiplomaDto, MySironaGetPersonDataDto, MySironaGetPersonLicenceDetailedDto, MySironaGetPersonLicenceDto, MySironaLegitimatedUser, MySironaPersonServiceProxy } from '@shared/service-proxies/service-proxies';

@Injectable({
    providedIn: 'root',
})
export class MySironaPersonService {
    _personId: number;
    personDataCached: MySironaGetPersonDataDto;

    constructor(private readonly mySironaPersonServiceProxy: MySironaPersonServiceProxy) {}

    public setPersonId(id: number): void {
        this._personId = id;
    }

    get personId(): number {
        return this._personId;
    }

    public getPersonData(): Observable<MySironaGetPersonDataDto> {
        if (this.personDataCached !== undefined) {
            return of(this.personDataCached);
        }

        return this.mySironaPersonServiceProxy
            .getPersonData(this._personId)
            .pipe(tap((x) => (this.personDataCached = x)));
    }

    public getLicencesForPerson(): Observable<MySironaGetPersonLicenceDto[]> {
        return this.mySironaPersonServiceProxy.getLicencesForPerson(this._personId);
    }

    public getPersonLicence(licenceId: number): Observable<MySironaGetPersonLicenceDetailedDto> {
        return this.mySironaPersonServiceProxy.getPersonLicence(licenceId);
    }

    public getDiplomasForPerson(personId: number): Observable<MySironaGetDiplomaDto[]> {
        return this.mySironaPersonServiceProxy.getDiplomasAndPostgraduateTitles(personId);
    }

    public getAcademicTitlesForPerson(personId: number): Observable<AcademicTitleSearchResultDto[]> {
        return this.mySironaPersonServiceProxy.getAcademicTitles(personId);
    }

    public hasPersonMutApplications(gln: string): Observable<number> {
        return this.mySironaPersonServiceProxy.hasPersonMutApplications(gln);
    }

    public createMut(mutationType: string): Observable<CreateMutOutput> {
        return this.mySironaPersonServiceProxy.createMut(mutationType, this.personId);
    }

    public getLegitimatedUsers(): Observable<MySironaLegitimatedUser[]> {
        return this.mySironaPersonServiceProxy.getLegitimations(this.personId, false);
    }
}
